export const MINT_ID = "MINT";
export const LOCK_ID = "LOCK";
export const STAKE_ID = "STAKE";
export const LOCK_MORE_ID = "LOCK_MORE";
export const DEPOSIT_ID = "DEPOSIT";
export const WITHDRAW_ID = "WITHDRAW";
export const REDEEM_ID = "REDEEM";
export const CLAIM_ID = "CLAIM";
export const WITHDRAW_LOCK_ID = "WITHDRAW_LOCK";
export const REALLOCATE_POINTS_ID = "REALLOCATE_POINTS";
export const CANCEL_EXIT_ID = "CANCEL_EXIT";
export const MULTIVOTE_ID = "MULTIVOTE_ID";
export const WITHDRAW_UNWOUND_ID = "WITHDRAW_UNWOUND_ID";

export const TRANSACTION_TYPES = {
    MINT: MINT_ID,
    LOCK: LOCK_ID,
    STAKE: STAKE_ID,
    LOCK_MORE: LOCK_MORE_ID,
    DEPOSIT: DEPOSIT_ID,
    WITHDRAW: WITHDRAW_ID,
    REDEEM: REDEEM_ID,
    CLAIM: CLAIM_ID,
    WITHDRAW_LOCK: WITHDRAW_LOCK_ID,
    REALLOCATE_POINTS: REALLOCATE_POINTS_ID,
    CANCEL_EXIT: CANCEL_EXIT_ID,
    MULTIVOTE: MULTIVOTE_ID,
    WITHDRAW_UNWOUND: WITHDRAW_UNWOUND_ID,
} as const;

export type TransactionType = keyof typeof TRANSACTION_TYPES;
